import { TodoDescriptor } from '../schema/TodoDescriptor';
import { OrderByValue } from 'owa-todo-service';
import { getOrderByValueForDescriptor } from './buildRequest/getOrderByValueForDescriptor';
import { compareTodosByOrderDateTime, compareTodosByCommittedOrder } from 'owa-todo-utils';
import { assertNever } from 'owa-assert';
import { trace } from 'owa-trace';

/**
 * Get the todo comparison function for a given descriptor
 *
 * @param descriptor TodoDescriptor
 */
export function getCompareForDescriptor(descriptor: TodoDescriptor) {
    // To ensure the compare functions align with the server side sorting that we are specifying when making our requests,
    // we use `getOrderByValueForDescriptor` (which is used to determine the sort when fetching tasks) to
    // determine the sort we should use here
    const sort = getOrderByValueForDescriptor(descriptor);
    switch (sort) {
        case OrderByValue.CompletedDateTime:
            // Ideally, we would compare by CompletedDateTime here, but there are a few problems with doing this:
            // 1. CompletedDateTime property is removed from the task when a task status is changed to "InProgress".
            // 2. CompletedDateTime represents the Date when task is finished with the time set to midnight. So, multiple tasks can have the same value for this.
            // These two things would make reliably sorting by this property require very involved front end lies.

            // Because of this, for now we'll compare by the OrderDateTime for our front end comparison. However, the OrderByValue
            // passed to the server in this case is still CompletedDateTime. This is needed because in the cases where we limit the number of items fetched
            // the OrderByValue passed to the server determines which items we get.
            return compareTodosByOrderDateTime;
        case OrderByValue.OrderDateTime:
            return compareTodosByOrderDateTime;
        case OrderByValue.CommittedOrder:
            return compareTodosByCommittedOrder;
        default:
            return assertNever(sort);
    }
}

/**
 * Get the subtodo comparison function for a given descriptor
 * @param descriptor TodoDescriptor
 */
export function getSubtodoCompareForDescriptor(descriptor: TodoDescriptor) {
    const sort = getOrderByValueForDescriptor(descriptor);
    switch (sort) {
        case OrderByValue.CompletedDateTime:
        // Ideally, we would compare by CompletedDateTime here, but there are a few problems with doing this:
        // 1. CompletedDateTime property is removed from the task when a task status is changed to "InProgress".
        // 2. CompletedDateTime represents the Date when task is finished with the time set to midnight. So, multiple tasks can have the same value for this.
        // These two things would make reliably sorting by this property require very involved front end lies.

        // Because of this, for now we'll compare by the OrderDateTime for our front end comparison.            return compareTodosByOrderDateTime;
        case OrderByValue.OrderDateTime:
            return compareTodosByOrderDateTime;
        default:
            trace.warn(
                `[getSubtodoCompareForDescriptor] Invalid order by value property for subtasks: ${sort}. Falling back to OrderDateTime comparison.`
            );
            return compareTodosByOrderDateTime;
    }
}
